/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./category-mirror.vue?vue&type=template&id=d2bae276&"
import script from "./category-mirror.vue?vue&type=script&lang=js&"
export * from "./category-mirror.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports